import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-album-test',
    templateUrl: './album-test.component.html',
    styleUrls: ['./album-test.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlbumTestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
